'use strict';

angular.module('shiftTraderApp')
  .controller('QuickCreateTemplateModalCtrl', function($scope, params, $uibModalInstance, TimeService, toastr,
                                                       ShiftTemplates, $timeout, $controller) {

    var baseCtrl = $controller('BaseQuickAddRowCtrl', {$scope: $scope, params: params, $uibModalInstance: $uibModalInstance});

    $scope.currentDate = TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime());
    $scope.originatingTemplate = params.originatingTemplate;
    $scope.mode = params.mode;

    _.each($scope.originatingTemplate.shifts, function(shift) {
      shift.$setDateForTimeCalcs($scope.currentDate);
    });

    $scope.templateFormData = {
      name: $scope.originatingTemplate.name,
      desc: $scope.originatingTemplate.description
    };

        // want to put the positionRows in the correct display order
    var originatingShiftsByPositionIndex = [];

    _.each($scope.allPositionsOrdered, function(x) {
      originatingShiftsByPositionIndex.push([]);
    });

    _.each($scope.originatingTemplate.shifts, function(shift) {
      var idx = _.findIndex($scope.allPositionsOrdered, {id: shift.position_id});
      if (idx > -1) {
        originatingShiftsByPositionIndex[idx].push(shift);
      }
    });

    _.map(originatingShiftsByPositionIndex, function(x) {
      return _.sortBy(x, '_startTimeUnix');
    });

    _.each($scope.allPositionsOrdered, function(pos, idx) {
      if (originatingShiftsByPositionIndex[idx].length > 0) {
        var entries = _(originatingShiftsByPositionIndex[idx]).map(function(shift) {
          return TimeService.minimalMomentFormat(shift.start_time, true) + '-' +
            TimeService.minimalMomentFormat(shift.end_time, true);
        }).value();

        var rawText = baseCtrl.simplifyEntries(entries).join(', ');

        $scope.positionRows.push({
          positionId: pos.id,
          rawText: rawText,
          objects: baseCtrl.parseRawText(rawText)
        });

        var idz = $scope.positionRows.length - 1;

        $scope.$watch(function() {
          return $scope.positionRows[idz].rawText;
        }, (function (idz) {
          return function (newVal) {
            console.log('WATCH FIRED: ', idz, ': ', newVal);
            var res = baseCtrl.parseRawText(newVal);

            $scope.positionRows[idz].objects = res;

            baseCtrl.calcTotalShifts();
          };
        })(idz));
      }
    });

    $scope.createShifts = function() {
      $scope.state = {
        totalShifts: 0,
        numShiftsCreated: 0,
        currentlyCreating: true
      };


      var bailout = false;
      _.each($scope.positionRows, function(row) {
        _.each(row.objects, function(obj) {
          if (!obj.d.parsed) {
            toastr.error('Please fix invalid shift time for the ' + _.find($scope.allPositions, {id: row.positionId}).name + ' position.', 'Error');
            bailout = true;
            return false;
          }
        });
      });

      if (bailout) {
        return false;
      }

      if ($scope.mode === 'clone' && $scope.originatingTemplate.name === $scope.templateFormData.name) {
        toastr.error('Please choose a different template name.', 'Error');
        $scope.state.currentlyCreating = false;
      } else {
        var postData = {
          organization_id: $scope.org.id,
          related_shift_template_id: $scope.originatingTemplate.id,
          name: $scope.templateFormData.name,
          description: $scope.templateFormData.desc,
          shift_data: _($scope.positionRows).map(function(row) {
            return _(row.objects).map(function(obj) {
              return {
                position_id: row.positionId,
                start_minutes: obj.d.start.hour * 60 + obj.d.start.min,
                end_minutes: obj.d.end.hour * 60 +  obj.d.end.min
              }
            }).value();
          }).flatten().value()
        };
        console.log(postData);


        ShiftTemplates.create(postData)
            .then(function(st) {

              toastr.success('Template created.', 'Success');
              if ($scope.mode === 'clone') {
                $uibModalInstance.close({
                  newTemplate: st,
                  oldTemplate: $scope.originatingTemplate
                });
              } else {
                $scope.originatingTemplate.$archive().then(function() {
                  $uibModalInstance.close({
                    newTemplate: st,
                    oldTemplate: $scope.originatingTemplate
                  });
                }, function() {

                });
              }

            }, function() {
              toastr.error('Looks like we had a problem creating your template.', 'Error');
            });
      }
    };
  });
